"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequirementInstanceResultOverrideStatusSchema = exports.RequirementInstanceResultOverrideStatus = void 0;
exports.convertOverrideStatusToEnum = convertOverrideStatusToEnum;
const zod_1 = require("zod");
var RequirementInstanceResultOverrideStatus;
(function (RequirementInstanceResultOverrideStatus) {
    RequirementInstanceResultOverrideStatus["Error"] = "error";
    RequirementInstanceResultOverrideStatus["Warning"] = "warning";
    RequirementInstanceResultOverrideStatus["Success"] = "success";
})(RequirementInstanceResultOverrideStatus || (exports.RequirementInstanceResultOverrideStatus = RequirementInstanceResultOverrideStatus = {}));
exports.RequirementInstanceResultOverrideStatusSchema = zod_1.z.nativeEnum(RequirementInstanceResultOverrideStatus);
function convertOverrideStatusToEnum(status) {
    switch (status) {
        case 'error':
            return RequirementInstanceResultOverrideStatus.Error;
        case 'warning':
            return RequirementInstanceResultOverrideStatus.Warning;
        case 'success':
            return RequirementInstanceResultOverrideStatus.Success;
        default:
            throw new Error(`Unknown override status: ${status}`);
    }
}
//# sourceMappingURL=RequirementInstanceResultOverrideStatus.js.map